import { render, staticRenderFns } from "./TopicHeader.vue?vue&type=template&id=e769498c&scoped=true"
import script from "./TopicHeader.vue?vue&type=script&lang=js"
export * from "./TopicHeader.vue?vue&type=script&lang=js"
import style0 from "./TopicHeader.vue?vue&type=style&index=0&id=e769498c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e769498c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e769498c')) {
      api.createRecord('e769498c', component.options)
    } else {
      api.reload('e769498c', component.options)
    }
    module.hot.accept("./TopicHeader.vue?vue&type=template&id=e769498c&scoped=true", function () {
      api.rerender('e769498c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/TopicHeader.vue"
export default component.exports